module.exports = __webpack_public_path__ + "media/images/coris-525dd1d7c55e87c0ba2feb79a11b8480.png";